import { axios } from "utils";

import { PUBLIC_PAGES_URL as endpoint } from "consts";

import { ContentPage, FullContentPage } from "models";

export const getPageLinks = async (data: { type: string; signal: AbortSignal }): Promise<ContentPage[]> =>
  axios.get(`${endpoint}/links`, { data, signal: data.signal });

export const getCurrentPlatformTermsAndConditions = async (): Promise<ArrayBuffer> => axios.get(`${endpoint}/platform-terms`, { responseType: "arraybuffer" });

export const getCurrentProgramTermsAndConditionsByProgramId = async (programId: string): Promise<ArrayBuffer> =>
  axios.get(`${endpoint}/program-terms/${programId}`, { responseType: "arraybuffer" });

export const getFullPage = async (data: { link: string; signal: AbortSignal }): Promise<FullContentPage> =>
  axios.get(`${endpoint}/${data.link}`, { data, signal: data.signal });
